import { render, staticRenderFns } from "./deptManagementList.vue?vue&type=template&id=b5f3c1bc&"
import script from "./deptManagementList.vue?vue&type=script&lang=js&"
export * from "./deptManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports